import React, { useState } from 'react';
import { carrierApi } from '../../firebase/functionsService';
import { isValidOrgNumber } from '../../utils/invoiceProfile';
import Field from './Field';
import { ui } from './carrierStyles';

const EMPTY = { name: '', contactName: '', phone: '', email: '', orgNumber: '', street: '', postalCode: '', city: '', note: '' };

function formFrom(customer) {
  if (!customer) return EMPTY;
  const a = customer.address ?? {};
  return {
    name: customer.name ?? '', contactName: customer.contactName ?? '', phone: customer.phone ?? '', email: customer.email ?? '',
    orgNumber: customer.orgNumber ?? '', street: a.street ?? '', postalCode: a.postalCode ?? '', city: a.city ?? '', note: customer.note ?? '',
  };
}

// Kunde i firmaets register (organizations/{orgId}/customers). Serveren validerer på nytt.
export default function CustomerForm({ orgId, customer = null, onSaved, onCancel }) {
  const [form, setForm] = useState(() => formFrom(customer));
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');
  const set = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));

  async function submit(e) {
    e.preventDefault();
    const found = {};
    if (!form.name.trim()) found.name = 'Skriv inn kundens navn';
    if (form.email.trim() && !/^\S+@\S+\.\S+$/.test(form.email.trim())) found.email = 'Skriv inn en gyldig e-postadresse';
    if (form.orgNumber.trim() && !isValidOrgNumber(form.orgNumber)) found.orgNumber = 'Ugyldig organisasjonsnummer (9 siffer)';
    if (form.postalCode.trim() && !/^\d{4}$/.test(form.postalCode.trim())) found.postalCode = 'Postnummer må være fire siffer';
    setErrors(found);
    if (Object.keys(found).length > 0) return;
    setStatus('saving');
    setMessage('');
    try {
      await carrierApi.saveCarrierCustomer({
        orgId,
        customerId: customer?.id ?? null,
        input: {
          name: form.name, contactName: form.contactName, phone: form.phone, email: form.email, orgNumber: form.orgNumber,
          address: { street: form.street, postalCode: form.postalCode, city: form.city }, note: form.note,
        },
      });
      setStatus('idle');
      if (onSaved) onSaved();
    } catch (err) {
      setStatus('error');
      setMessage(err.message || 'Kunne ikke lagre kunden');
    }
  }

  return (
    <form onSubmit={submit} noValidate>
      <Field id="c-name" label="Navn" error={errors.name}>
        <input id="c-name" style={ui.input} value={form.name} onChange={set('name')} maxLength={120} />
      </Field>
      <div style={ui.row}>
        <Field id="c-contact" label="Kontaktperson" style={{ flex: 1, minWidth: 160 }}>
          <input id="c-contact" style={ui.input} value={form.contactName} onChange={set('contactName')} maxLength={80} />
        </Field>
        <Field id="c-phone" label="Telefon" style={{ flex: 1, minWidth: 140 }}>
          <input id="c-phone" style={ui.input} value={form.phone} onChange={set('phone')} inputMode="tel" maxLength={30} />
        </Field>
      </div>
      <Field id="c-email" label="E-post" error={errors.email}>
        <input id="c-email" style={ui.input} value={form.email} onChange={set('email')} maxLength={120} />
      </Field>
      <Field id="c-org" label="Organisasjonsnummer" error={errors.orgNumber}>
        <input id="c-org" style={ui.input} value={form.orgNumber} onChange={set('orgNumber')} inputMode="numeric" />
      </Field>
      <Field id="c-street" label="Gateadresse">
        <input id="c-street" style={ui.input} value={form.street} onChange={set('street')} maxLength={120} />
      </Field>
      <div style={ui.row}>
        <Field id="c-postal" label="Postnummer" error={errors.postalCode} style={{ flex: '0 0 120px' }}>
          <input id="c-postal" style={ui.input} value={form.postalCode} onChange={set('postalCode')} inputMode="numeric" maxLength={4} />
        </Field>
        <Field id="c-city" label="Poststed" style={{ flex: 1, minWidth: 160 }}>
          <input id="c-city" style={ui.input} value={form.city} onChange={set('city')} maxLength={80} />
        </Field>
      </div>
      <Field id="c-note" label="Notat">
        <input id="c-note" style={ui.input} value={form.note} onChange={set('note')} maxLength={500} />
      </Field>
      {status === 'error' && <p role="alert" style={ui.error}>{message}</p>}
      <div style={{ ...ui.row, marginTop: 14 }}>
        <button type="submit" className="tippi-btn" style={ui.btn} disabled={status === 'saving'}>
          {status === 'saving' ? 'Lagrer…' : 'Lagre kunde'}
        </button>
        {onCancel && <button type="button" style={ui.btnSecondary} onClick={onCancel}>Avbryt</button>}
      </div>
    </form>
  );
}
